export default __webpack_public_path__ + "static/media/TOB.3ad7d842.png";